import isNumber from 'lodash-es/isNumber'
import { FC } from 'react'

import { Media } from '@syconium/little-miss-figgy'

import { siteName } from '../../../../../constants/figs'
import { ProductReviewsContainer } from '../../../../../containers/ProductReviewsContainer'
import { useReviewsProductGroupDataContext } from '../../../../../containers/ReviewsProductGroupDataService/useReviewsProductGroupData'

import { AverageFit } from './AverageFit'
import { BaselineImage } from './BaselineImage'
import { FitSurvey } from './FitSurvey'
import { StarDistribution } from './StarDistribution'
import { Body, Spacer } from './styles'
import { FitSurveyItem } from './types'

export const ReviewBaseline: FC<{ fitFields?: Array<FitSurveyItem> }> = ({ fitFields }) => {
  const { data: productData } = useReviewsProductGroupDataContext()
  const { results } = ProductReviewsContainer.useContainer()

  const productName = productData?.title
  const averageFit = results?.averageFit
  const averageScore = results?.averageScore ?? 0
  const totalCount = results?.totalReviews ?? 0

  const details =
    totalCount > 0 ? (
      <>
        <Spacer>
          <StarDistribution rating={averageScore} totalReviews={totalCount} />
        </Spacer>

        {isNumber(averageFit) && (
          <Spacer>
            <AverageFit fit={averageFit} />
          </Spacer>
        )}
      </>
    ) : null

  return (
    <Body>
      {productData?.imageUrl ? (
        <BaselineImage imageSrc={productData.imageUrl} title={productName ?? siteName}>
          <Media greaterThanOrEqual='md'>{details}</Media>
        </BaselineImage>
      ) : null}

      <Media lessThan='md'>{details}</Media>

      {!!fitFields && (
        <Spacer>
          <FitSurvey fitFields={fitFields} />
        </Spacer>
      )}
    </Body>
  )
}
